<ik-modal (OnClose)="dialogRef.close()">
    <ng-container header>
        {{'Adresses de facturation' | transloco}}
    </ng-container>
    <ng-container main>
        <div class="description">
            <span [innerHTML]="'Votre partenaire sera uniquement autorise a utiliser l\'adresse definie comme <strong>adresse de facturation par defaut</strong> dans votre organisation <strong>$organization$</strong>.' | transloco:{
                organization: data.defaultBillingAddress.organization_name 
                ? data.defaultBillingAddress.organization_name 
                : data.defaultBillingAddress.first_name + ' ' + data.defaultBillingAddress.last_name }"></span>
        </div>
        <div class="addresses">
            <div class="address">
                <div class="address-left">
                    <div class="address-left__organization">
                        <ng-container
                                      [ngSwitch]="data.defaultBillingAddress.organization_name !== undefined && data.defaultBillingAddress.organization_name !== null">
                            <ng-container *ngSwitchCase="true">
                                {{data.defaultBillingAddress.organization_name}}
                            </ng-container>
                            <ng-container *ngSwitchCase="false">
                                {{data.defaultBillingAddress.first_name}} {{data.defaultBillingAddress.last_name}}
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="address-left__street">
                        {{data.defaultBillingAddress.street}}
                    </div>
                    <div class="address-left__code">
                        {{data.defaultBillingAddress.zip_code}} {{data.defaultBillingAddress.city}}
                        {{data.defaultBillingAddress.country}}
                    </div>
                </div>
            </div>
        </div>
        <div class="description">
            <span [innerHTML]="customText"></span>
        </div>
    </ng-container>
    <ng-container footer>
        <button class="btn-close"
                mat-flat-button
                mat-dialog-close
                [attr.aria-label]="'Fermer' | transloco"
                color="accent">
            {{ 'Fermer' | transloco }}
        </button>
    </ng-container>
</ik-modal>
